import initialState from './initialstate';
import * as types from '../Actions/actiontypes';
import {documentTypes} from '../../../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */

export default function HandOffTaskDocumentsReducer(state = initialState.handOffTaskDocs, action) {
	switch (action.type) {
		case types.HO_GET_EVIDENCES: {
			let evidenceList =
				action.response.data && action.response.data.length ? constructEvidenceList(action, state, 'approvals') : null;

			return {
				...state,
				evidences: evidenceList ?? [],
				initialEvidenceCollection: evidenceList
			};
		}

		case types.HO_GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY:
			// Only take the fields coming from the API response.
			let taskDocumentsStatusAndFlags = action.response;
			return {
				...state,
				loggedInUserId: taskDocumentsStatusAndFlags.loggedInUserId,
				taskStatusId: taskDocumentsStatusAndFlags.taskStatusId,
				reHandOff: taskDocumentsStatusAndFlags.reHandOff,
				enableHandOff: taskDocumentsStatusAndFlags.enableHandOff,
				enableButton: taskDocumentsStatusAndFlags.enableButton,
				enableHandoffforPgat: taskDocumentsStatusAndFlags.enableHandoffforPgat,
				enableCompleteButton: taskDocumentsStatusAndFlags.enableCompleteButton,
				enableReturned: taskDocumentsStatusAndFlags.enableReturned,
				enableSendButton: taskDocumentsStatusAndFlags.enableSendButton,
				isEPEQRSignoffComplete: taskDocumentsStatusAndFlags.isEPEQRSignoffComplete,
				isEPSignOffRequired: taskDocumentsStatusAndFlags.isEPSignOffRequired,
				isEQRSignOffRequired: taskDocumentsStatusAndFlags.isEQRSignOffRequired,
				isEPSignOffUserRequired: taskDocumentsStatusAndFlags.isEPSignOffUserRequired,
				isEQRSignOffUserRequired: taskDocumentsStatusAndFlags.isEQRSignOffUserRequired,
				isDocumentsInTransit: taskDocumentsStatusAndFlags.istaskDocumentsStatusAndFlagsDocumentsInTransit,
				hasEQRSignOff: taskDocumentsStatusAndFlags.hasEQRSignOff,
				hasEPSignOff: taskDocumentsStatusAndFlags.hasEPSignOff
			};

		case types.HO_UPDATE_SIGNOFF_GIVEN_DOCUMENTS:
			let existingEvidences = JSON.parse(JSON.stringify(state.evidences));
			let updatedEvidencesWithSignOff = existingEvidences.map((evidence) => {
				if (
					evidence.documentTypeId !== documentTypes.PAPERPROFILE &&
					_.includes(action.documentIds, evidence.documentId)
				) {
					return {
						...evidence,
						isPrepRevSignOff: action.approvalType
					};
				} else {
					return evidence;
				}
			});
			return {
				...state,
				evidences: updatedEvidencesWithSignOff
			};

		case types.HO_CLEAR_HANDSOFF_TASK_DOCUMENTS:
			return {};

		case types.HO_UPDATE_SIGNOFF_INDIVIDUAL_DOCUMENT:
			let newevidences = JSON.parse(JSON.stringify(state.evidences));
			newevidences.map((evidence) => {
				if (evidence.documentId === action.documentId) {
					var updateEvidence = evidence;
					updateEvidence.isPrepRevSignOff = action.approvalType;
					Object.assign({}, updateEvidence);
				}
			});
			return {
				...state,
				evidences: newevidences
			};

		default:
			return state;
	}
}

function constructEvidenceList(action, state, key) {
	let evidenceList = [];
	for (let i = 0; i < action.response.data.length; i++) {
		let document = action.response.data[i];
		let newDocument = {
			documentId: document.id,
			documentName: document.documentName,
			fileExt: document.fileExt,
			documentTypeId: document.documentTypeId,
			signOffs: document[key],
			isShared: document.isShared,
			hasComments: document.hasComments,
			hasHiddenSheets: document.hasHiddenSheets,
			hasHighlights: document.hasHighlights,
			hasTaskSystemAssociated: document.hasTaskSystemAssociated,
			sourceEngagementId: document.sourceEngagementId ? document.sourceEngagementId : document.engagementId,
			isPrepRevSignOff: null,
			isEPSignoffRequired: document.isEPSignoffRequired,
			isEPSignoffUserRequired: document.isEPSignoffUserRequired,
			isEQRSignoffRequired: document.isEQRSignoffRequired,
			isEQRSignoffUserRequired: document.isEQRSignoffUserRequired
		};

		evidenceList.push(newDocument);
	}
	return evidenceList;
}
